import { AppMode } from './AppMode';
import { ListStyle } from './Components/ListStyle';
import { Settings } from './Settings';

const StaticSettings: Settings = {
    client: {
        name: 'Steiner Personal'
    },
    mode: AppMode.JobVacancy,
    limitToDepartment: false,
    ui: {
        list: {
            style: ListStyle.Grid,
            showHeader: false,
            jobVacancySortBy: 'creationDate',
            candidateSortBy: undefined
        },
        detail: {
            showIndustry: false,
            showFilter: false,
            showSharing: false,
        },
        pagination: {
            pageSize: 9,
            // labels: {
            //     first: 'Anfang', // First
            //     last: 'Letzte', // Last
            //     previous: 'Vorherige', // Previous
            //     next: 'Nächste', // Next
            // }
        },
        showTypeSwitcherTabs: false,
        filter: {
            showSearchButton: false
        },
        allowApplyToMultiple: false,
        showJobStartDate: false,
    },
    uri: {
        jobVacancyFormAnchor: '#job-center-form-anchor',
        candidateFormAnchor: undefined,
    }

};
export { StaticSettings };
